/* eslint-disable import/prefer-default-export */
export const LOAD_FILES = 'LOAD_FILES';
export const RESIZE_LAYOUT = 'RESIZE_LAYOUT';
export const RESIZE_ITEMS = 'RESIZE_ITEMS';



/** WEBPACK FOOTER **
 ** ./src/data/actions.js
 **/